unable to read source [project]/node_modules/stripe/src/resources/V2/index.ts